
import React from "react"; 

import {
  Box,
  Typography,
  // IconButton,
  // Menu,
  // MenuItem,
  // Divider,
  // ListItemIcon,
  // Table,
  // TableBody,
  // TableCell,
  // TableContainer,
  // TableHead,
  // TableRow,
  Snackbar, CircularProgress
} from "@mui/material";
function ProgressBar({ processingMessage = "Processing...", showProcessingSnackbar }) {
  return (
    <Snackbar
      open={showProcessingSnackbar}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      sx={{
        '& .MuiSnackbarContent-root': {
          backgroundColor: "#191919",
          background: "rgba(31, 31, 31, 1)",
          color: '#fff',
        }
      }}
      message={
        <Box display="flex" alignItems="center">
          <CircularProgress size={20} style={{ marginRight: 8 }} />
          <Typography>{processingMessage}</Typography>
        </Box>
      }
    />
  )
}

export default ProgressBar